import { useState } from 'react';

const faqItems = [
  {
    q: '每日大赛入口是什么？',
    a: '每日大赛入口是一个专注于各类大赛视频作品介绍与类型整理的在线内容平台，每日更新收录热门大赛作品，提供从舞蹈、音乐、创意到科技等30多种大赛类型的详细列表和推荐，帮助用户快速找到感兴趣的大赛视频内容。',
  },
  {
    q: '每日大赛入口覆盖哪些大赛类型？',
    a: '平台覆盖的大赛类型十分广泛，包括但不限于街舞大赛、歌唱比赛、创意设计大赛、编程竞赛、短视频创作大赛、摄影大赛、美食大赛、cosplay大赛等，每日大赛列表持续扩充，满足不同兴趣用户的需求。',
  },
  {
    q: '每日大赛入口的内容多久更新一次？',
    a: '每日大赛入口坚持每日更新，运营团队持续追踪各大平台和社区的热门大赛视频动态，及时整理最新的每日大赛作品介绍和排行信息，确保用户每天都能发现新鲜内容。',
  },
  {
    q: '如何快速找到感兴趣的大赛视频？',
    a: '你可以通过每日大赛入口首页的话题标签、热门排行和专题索引快速浏览。每日大全汇总了所有类型的大赛信息，大赛类型分类清晰，图文卡片直观展示作品亮点，帮你高效定位目标内容。',
  },
  {
    q: '每日大赛入口是否需要注册登录？',
    a: '每日大赛入口目前为公开的内容展示平台，所有每日大赛作品介绍、大赛类型列表和每日大全均可免费浏览，无需注册登录即可访问全部内容。',
  },
  {
    q: '每日大赛入口的大赛视频来自哪里？',
    a: '每日大赛入口汇总来自各大主流视频平台和社区的大赛相关内容，整理为每日大赛列表供用户参考。平台本身不托管视频文件，而是以作品介绍、类型归纳和推荐索引的方式帮助用户发现优质大赛内容。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-3">
          常见问答
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          关于每日大赛入口的常见问题，快速了解我们的每日大赛作品介绍服务
        </p>

        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="rounded-xl border border-background-200/80 bg-background-50 overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => toggle(i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {item.q}
                </h3>
                <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIndex === i ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}